import { fetchThemeFile } from 'owa-theme/lib/selectors/fetchThemeResource';
import loadTheme from 'owa-theme/lib/actions/loadTheme';
import { normalizeThemeRequest } from 'owa-theme/lib/utils/normalizeThemeId';

export async function loadInitialTheme(
    themeStorageId: string,
    darkMode: boolean,
    themesAllowed: boolean
) {
    let { themeId, isDarkTheme } = normalizeThemeRequest(themeStorageId, darkMode, themesAllowed);
    await fetchThemeFile(themeId, isDarkTheme);
    loadTheme(themeId, isDarkTheme, themesAllowed);
}
